import request from '@/utils/request'

const http = request()

export const listSms = params => http.post('/sms/list', params)

export const listSmsTemplate = params => http.post('/sms/template/list', params)

export const bindSmsTemplate = params => http.post('/sms/template/bind', params)

export const modifySmsTemplate = params => http.post('/sms/template/modify', params)

export const syncSmsTemplate = templateCode => http.post('/sms/template/sync', { templateCode })

export const delSmsTemplate = templateCode => http.post('/sms/template/delete', { templateCode })
